module.exports = __webpack_public_path__ + "img/KeyPal-plus.f82c3773.png";